module.exports = __webpack_public_path__ + "img/quality-traceability.d91ae6b1.png";